import type { FaireProductEntity } from "../../entity_types/product";

export const p_dnun2puj62: FaireProductEntity = {
  token: "p_dnun2puj62",
  type: "product",
  name: "Spicy Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/888903f92ea3352f25ed54516e468a1f2a8723668cf47bdeba44f67ad1447230.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d04d6a391015a52122b6c5073c1c8b9e66b91d3bec1527284cdbda1eb5e08959.jpeg",
    "https://cdn.faire.com/fastly/e6a0da75d766aa42d81eac2bd8fc32a7d410b2d31d6be26e745f11554e82e5cb.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/dbd4f0adb2dc21287d02b77235860c0842e304068607ec815532fae88c61e8d1.jpeg",
    "https://cdn.faire.com/fastly/9c11700e2f208714445b25a03d977a3636b404d6fedb7c58435138a47ad18c47.jpeg",
    "https://cdn.faire.com/fastly/44b7d2ce1215ec1eeecda67d8dd1e8488564f49ca5f3e02d4c34922b4ba48229.jpeg",
    "https://cdn.faire.com/fastly/1ecae66fb9e1bfdcdff311ab592ba904547fa5704f91ac839d6712998b74d2d6.jpeg"
  ],
  priceDollars: 9.6,
  description: "If you naturally bring the heat wherever you go... you should spice up your workouts in these grip socks! 🌶️\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:08.431Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
